import { ReportOrderType } from '@driftt/api-types'

export enum EmailCampaignMetricType {
  ENROLLED = 'ENROLLED',
  UNENROLLED = 'UNENROLLED',
  COMPLETED = 'COMPLETED',
  SENT = 'SENT',
  DELIVERED = 'DELIVERED',
  OPENED = 'OPENED',
  CLICKED = 'CLICKED',
  REPLIED = 'REPLIED',
  BOUNCED = 'BOUNCED',
  UNSUBSCRIBED = 'UNSUBSCRIBED',
}

export enum EmailCampaignStatuses {
  ENABLED = 'ENABLED',
  DISABLED = 'DISABLED',
  ARCHIVED = 'ARCHIVED',
}

export enum EmailCampaignSortProperties {
  TITLE = 'title',
  LAST_CREATED = 'last_created',
  LAST_UPDATED = 'last_updated',
}

export enum PersonInEmailStatus {
  ENROLLED = 'Enrolled',
  UNENROLLED = 'Unenrolled',
  UNENROLLED_MANUALLY = 'Unenrolled_manually',
  UNENROLLED_EXIT_SEGMENT = 'Unenrolled_exit_segment',
  UNENROLLED_IN_EXCLUSION_SEGMENT = 'Unenrolled_in_exclusion_segment',
  UNENROLLED_SALES_ENGAGED = 'Unenrolled_sales_engaged',
  UNENROLLED_REPLIED = 'Unenrolled_replied',
  UNENROLLED_PLAYBOOK_DISABLED = 'Unenrolled_playbook_disabled',
  UNENROLLED_BOUNCED = 'Unenrolled_bounced',
  COMPLETED = 'Completed',
  BOUNCED = 'Bounced',
  UNSUBSCRIBED = 'Unsubscribed',
}

enum CampaignAudienceExclusivity {
  NO = 1,
  YES = 2,
}

export type EmailCampaignMetricsByCampaign = Record<
  'byCampaign',
  EmailCampaignMetricsResponse[]
>
export interface EmailCampaignPageParams {
  pageStart: number
  pageSize: number
  sortProperty: EmailCampaignSortProperties
  sortDirection: ReportOrderType
  nameQuery?: string
  filterByStatuses: EmailCampaignStatuses[]
}

export interface EmailCampaignPageMetricsParams {
  startDate: string
  endDate: string
  campaignIds: number[]
}

export interface EmailCampaignMetricsParams {
  startDate: string
  endDate: string
  prevStartDate: string
  prevEndDate: string
}

export interface PeopleInEmailCampaignPageParams {
  startDate: string
  endDate: string
  size: number
  page?: number
  sortOrder?: ReportOrderType
  emailId?: number
  responseClassification?: string
  metric?: EmailCampaignEventType
  endUserSearch?: string
}

interface EmailCampaignMetricsResponse {
  campaignId: number
  metrics: EmailCampaignMetric[]
}

export type EmailCampaignMetricByType = Record<
  EmailCampaignMetricType,
  { value: number }
>

export interface EmailCampaignReportResponse {
  byDate: {
    current: { date: string; metrics: EmailCampaignMetricByType }[]
    previous: { date: string; metrics: EmailCampaignMetricByType }[]
  }
  byEmail: { emailInCampaignId: number; metrics: EmailCampaignMetricByType }[]
  total: EmailCampaignMetricByType
}
export interface EmailCampaignMetric {
  displayName: string
  key: EmailCampaignMetricType
  lastSeen: {
    type: string
    value: string
  }
  metric: {
    type: string
    value: number
  }
}

export interface EmailCampaignPageResponse {
  emailCampaigns: EmailCampaign[]
  meta: {
    next: number
    total: number
    totalPages: number
  }
}

export interface EmailCampaign {
  id: number
  orgId: number
  title: string
  createdAt: number
  updatedAt: number
  createdAuthorId: number
  updatedAuthorId: number
  status: EmailCampaignStatuses
  senderName: string
  senderEmail: string
  smartSending: boolean
  weekdaysOnly: boolean
  unenrollOnReply: boolean
  emails: EmailInCampaign[]
  audience: Audience
  replyBotId: string
  exclusivity: CampaignAudienceExclusivity
}

export interface PeopleInCampaignPageResponse {
  people: EndUserInCampaign[]
  remaining: number
}

export interface EndUserInCampaign {
  endUserId: number
  email: string
  name: string
  companyName: string
  enrolledAt: number
  lastSendAt: number
  lastSentEmailCampaignId: number
  opened: boolean
  clicked: boolean
  replied: boolean
  status: PersonInEmailStatus
  nextSendAt?: number
  unenrolledBy?: number
  sentFrom?: number
}

export interface EmailInCampaign {
  id: number
  orgId?: number
  delay: number
  delayUnit: string
  subjectLine: string
  createdAt: number
  createdAuthorId?: number
  body: string
  threadedWithPrevious: boolean
  previousEmailInCampaignId: number | null
  nextEmailInCampaignId: number | null
  isTestEmail: boolean
}

interface Audience {
  audienceInclude: number[]
  dynamicAudienceInclude: number[]
  audienceExclude: number[]
}

export enum EmailCampaignEventType {
  OPENED = 'OPENED',
  CLICKED = 'CLICKED',
  REPLIED = 'REPLIED',
}

export interface UnenrollFromCampaignPayload {
  endUserId: number
  emailCampaignId: number
  unenrolledById: number
}

export interface UnenrollFromCampaignParallelPayload {
  endUsers: EndUserInCampaign[]
  emailCampaignId: number
  currentUserId: number
}
